module.exports = __webpack_public_path__ + "static/media/aa10.dc78b218.jpg";